module.exports = __webpack_public_path__ + "static/media/Logo-Horizontal2.a02e89f9.png";